/**
 * A tiny event bus so the visual layer (pixel-art messengers, watcher) can react
 * to session events without coupling to the runtime internals.
 */

export type WinterEvent =
  | { type: 'mutate'; fragmentId: string; parentId: string; op: string }
  | { type: 'cultivate'; fragmentId: string }
  | { type: 'observe'; fragmentId: string; text: string }
  | { type: 'watching'; active: boolean };

type Listener = (e: WinterEvent) => void;

const listeners = new Set<Listener>();

export function onWinterEvent(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function emitWinterEvent(e: WinterEvent): void {
  for (const fn of listeners) {
    try {
      fn(e);
    } catch {
      /* a bad listener must not break the session */
    }
  }
}
